import React from 'react'
import 'dropzone/dist/min/dropzone.min.css'
import 'react-dropzone-component/styles/filepicker.css'
import DropzoneComponent from 'react-dropzone-component'
import ApiRequest from 'EurestoApi/ApiRequest'

import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress'
import Grid from '@material-ui/core/Grid/Grid'
import avatarProduit from 'EurestoStyle/font/avatarProduit.png'
import avatarEntite from 'EurestoStyle/font/avatarEntite.png'
import avatarPersonne from 'EurestoStyle/font/avatarPersonne.png'

const project = require('EurestoConfig/project.config')

export default class DefaultUpload extends React.Component {
  constructor(props) {
    super(props)
    let template = this.props.template || ''
    let maxFileSize = 0
    let addRemoveLinks
    let acceptedFiles
    let iconFileTypes
    let showFiletypeIcon
    let loadVisu
    let clickable = true
    switch (template) {
      case 'logo':
      case 'photo':
        maxFileSize = 600
        addRemoveLinks = false
        acceptedFiles = 'image/*'
        iconFileTypes = []
        showFiletypeIcon = false
        loadVisu = <img width={'auto'}
          height={'auto'}
          style={props.avatarStyle}
          src={this.props.src ||
            (this.props.type === 'produit' && avatarProduit || this.props.type === 'entite' && avatarEntite || avatarPersonne)} />
        break

      default:
        maxFileSize = 500
        addRemoveLinks = false
        acceptedFiles = '*'
        //iconFileTypes = ['.jpg', '.png', '.gif', '.pdf', '.mp4', '.xls']
        showFiletypeIcon = false
        clickable = this.props.clickable ? this.props.clickable : false
        //loadVisu = EurestoI18n.t('commun:Déposez vos fichier ici pour les ajouter')
        break
    }

    this.djsConfig = {
      addRemoveLinks: addRemoveLinks,
      acceptedFiles: acceptedFiles,
      maxFilesize: maxFileSize,
      clickable: clickable,
      //previewTemplate: false,
      previewElement: false,
      //chunkSize: 7000000,
      autoProcessQueue: false
    }

    this.componentConfig = {
      iconFiletypes: iconFileTypes,
      showFiletypeIcon: showFiletypeIcon,
      postUrl: 'no-url',
      clickable: clickable
    }

    this.state = {
      visuUpload: loadVisu,
      action_id: this.props.action,
      uploading: false
    }

  }

  getBase64 = (file) => {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const base64Result = reader.result.substr(reader.result.indexOf(',') + 1)
      this.apiSend(file, base64Result)
    }

    reader.onerror = function (error) {
      console.log('Error: ', error)
    }
  }

  apiPrepareSend = (file) => {
    let idFileBase64 = ''
    if (file.dataURL === undefined) {
      this.getBase64(file)
    } else {
      idFileBase64 = file.dataURL
      const base64Result = idFileBase64.substr(idFileBase64.indexOf(',') + 1)
      this.setState({
        uploading: true
      }, () => this.apiSend(file, base64Result))
    }
  }

  onPaste = event => {
    var items = (event.clipboardData || event.originalEvent.clipboardData).items;
    for (let index in items) {
      var item = items[index];
      if (item.kind === 'file') {
        this.base64PasteFile(item.getAsFile())
      }
    }
  }

  base64PasteFile = (file) => {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const base64Result = reader.result.substr(reader.result.indexOf(',') + 1)
      this.apiSend(file, base64Result)
    }

    reader.onerror = function (error) {
      console.log('Error: ', error)
    }
  }

  eventHandlers = {
    addedfile: file => this.apiPrepareSend(file),
  }

  render() {
    const config = this.componentConfig
    const djsConfig = this.djsConfig
    // For a list of all possible events (there are many), see README.md!
    if (this.props.children) {
      return <div onPaste={this.onPaste} style={Object.assign({ position: 'relative' }, this.props.style || {})}>{this.props.disabled !== true ? (
        <DropzoneComponent config={config} eventHandlers={this.eventHandlers} djsConfig={djsConfig}>
          <div className="dz-message" style={{ margin: 0 }}>{this.props.children}</div>
          {
            this.state.uploading &&
            <Grid container spacing={0} style={Object.assign({ margin: 0, padding: 0, height: '100%', width: '100%', position: 'absolute', left: 0, top: 0 }, this.props.style || {})}
              direction="column" justify={'center'} alignContent={'center'} alignItems={'center'}><CircularProgress
                size={100} thickness={4} style={{ zIndex: 100 }} className={'EurestoPrimary--text'} />
            </Grid>
          }
        </DropzoneComponent>) : <div className="dz-message" style={{ margin: 0 }}>{this.props.children}</div>}</div>
    } else {
      return (<div style={this.props.style || {}}>{this.props.disabled !== true ? (
        <DropzoneComponent config={config} eventHandlers={this.eventHandlers} djsConfig={djsConfig}>
          <div className="dz-message" style={{ margin: 0 }}>{this.state.visuUpload}</div>
        </DropzoneComponent>) : <div className="dz-message">{this.state.visuUpload}</div>}</div>)
    }

  }

  apiSend = async (file, base64) => {
    if (this.props.catchedUploadFile) {
      return this.setState({
        uploading: false
      }, () => this.props.catchedUploadFile(file, base64))
    }
    let jsonGet = {
      requete: 'media',
      action: 'add',
      type_fichier: file.type,
      base64: base64,
      libelle: file.name,
      contact_id: this.props.contact_id || '',
      type_media_id: this.props.typeFichier && this.props.typeFichier.id || 99,
      action_id: this.state.action_id || ''
    }

    console.log(project.api + 'commun')

    ApiRequest(project.api + 'commun', jsonGet)
      .then((result) => {
        this.setState({
          uploading: false
        }, () => {
          result && result.code === 1 && this.props.handleUploaded && this.props.handleUploaded(result)
        })
      })
      .catch((err) => {
        console.log(err)
        this.setState({
          uploading: false
        })
      })
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Upload/DefaultUpload.js